import React from 'react'
import PubSub from 'pubsub-js'
import classNames from 'classnames'
import {Alert, Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap'
import apiBarcode from '../../services/api/apiBarcode'
import parseGGDriver from './parseGGDriver'
import {pushNewItemHistory} from "../../services/api/apiItemHistory"
import className from "classnames"

class PrintItem extends React.Component {
    constructor(props) {
        super(props)

        const {product} = props
        const {
            status: productStatus,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight
        } = product
        let arrCanPrint = []
        switch (productStatus) {
            case 'created':
                if(designFront) {
                    arrCanPrint.push('printed_front')
                } else if(designBack) {
                    arrCanPrint.push('printed_back')
                } else if(designSleeveLeft) {
                    arrCanPrint.push('printed_sleeves_left')
                } else if(designSleeveRight) {
                    arrCanPrint.push('printed_sleeves_right')
                }
                break
            case 'printed_front':
                if(designBack) {
                    arrCanPrint.push('printed_back')
                } else if(designSleeveLeft) {
                    arrCanPrint.push('printed_sleeves_left')
                } else if(designSleeveRight) {
                    arrCanPrint.push('printed_sleeves_right')
                }
                break
            case 'printed_back':
                if(designSleeveLeft) {
                    arrCanPrint.push('printed_sleeves_left')
                } else if(designSleeveRight) {
                    arrCanPrint.push('printed_sleeves_right')
                }
                break
            case 'printed_sleeves_left':
                if(designSleeveRight) {
                    arrCanPrint.push('printed_sleeves_right')
                }
                break
        }

        this.state = {
            isLoadingFrontPrinting: false,
            isLoadingBackPrinting: false,
            isLoadingSleeveLeftPrinting: false,
            isLoadingSleeveRightPrinting: false,
            note: '',
            isLoadingNote: false,
            isLoadingMarkWrong: false,
            errorMarkWrong: '',
            validated: false,
            arrCanPrint
        }
    }

    componentDidMount() {
        this._loadStateFromProps()
    }

    _loadStateFromProps = () => {
        const {item} = this.props
        const {note} = item

        this.setState({note})
    }

    _renderIconPrintFront = () => {
        if (this.state.isLoadingFrontPrinting) {
            return <i className='icon-spinner2 spinner  ml-2'/>
        }

        return <i className='icon-printer ml-2'/>
    }

    _renderIconPrintBack = () => {
        if (this.state.isLoadingBackPrinting) {
            return <i className='icon-spinner2 spinner  ml-2'/>
        }

        return <i className='icon-printer ml-2'/>
    }

    _renderIconPrintSleeveLeft = () => {
        if (this.state.isLoadingSleeveLeftPrinting) {
            return <i className='icon-spinner2 spinner  ml-2'/>
        }

        return <i className='icon-printer ml-2'/>
    }

    _renderIconPrintSleeveRight = () => {
        if (this.state.isLoadingSleeveRightPrinting) {
            return <i className='icon-spinner2 spinner  ml-2'/>
        }

        return <i className='icon-printer ml-2'/>
    }

    _handleClickPrintFront = async () => {
        this.setState({
            isLoadingFrontPrinting: true
        })

        try {
            const {item, product, reloadItem} = this.props
            const {designBack, designSleeveLeft, designSleeveRight} = product
            const name = localStorage.getItem('name') || ''
            const status = (designBack || designSleeveLeft || designSleeveRight) ? 'printed_front' : 'completed'

            const resUpdated = await apiBarcode.updateBarcodeProduct(item._id, product._id, {status, printed_ip: name})

            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)

            setTimeout(() => {
                const {barcodeNumber} = this.props
                return pushNewItemHistory(barcodeNumber, {
                    event_key: 'mark_as_printed',
                    event_description: 'Mark front side as printed.',
                    event_meta: {
                        status
                    }
                })
            }, 0)

            await reloadItem()

            PubSub.publish('FOCUS_INPUT_SEARCH')
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingFrontPrinting: false})
    }

    _handleClickPrintBack = async () => {
        this.setState({isLoadingBackPrinting: true})

        try {
            const {item, product, reloadItem} = this.props
            const {designSleeveLeft, designSleeveRight} = product
            const status = (designSleeveLeft || designSleeveRight) ? 'printed_back' : 'completed'

            const resUpdated = await apiBarcode.updateBarcodeProduct(item._id, product._id, {status});

            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)

            setTimeout(() => {
                const {barcodeNumber} = this.props
                return pushNewItemHistory(barcodeNumber, {
                    event_key: 'mark_as_printed',
                    event_description: 'Mark back side as printed.',
                    event_meta: {
                        status
                    }
                })
            }, 0)

            await reloadItem()

            PubSub.publish('FOCUS_INPUT_SEARCH')
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingBackPrinting: false})
    }

    _handleClickPrintSleeveLeft = async () => {
        this.setState({
            isLoadingSleeveLeftPrinting: true
        })

        try {
            const {item, product, reloadItem} = this.props
            const {designSleeveRight} = product
            const status = (designSleeveRight) ? 'printed_sleeves_left' : 'completed'

            const resUpdated = await apiBarcode.updateBarcodeProduct(item._id, product._id, {status})

            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)

            setTimeout(() => {
                const {barcodeNumber} = this.props
                return pushNewItemHistory(barcodeNumber, {
                    event_key: 'mark_as_printed',
                    event_description: 'Mark sleeve left as printed.',
                    event_meta: {
                        status
                    }
                })
            }, 0)

            await reloadItem()

            PubSub.publish('FOCUS_INPUT_SEARCH')
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingSleeveLeftPrinting: false})
    }

    _handleClickPrintSleeveRight = async () => {
        this.setState({
            isLoadingSleeveRightPrinting: true
        })

        try {
            const {item, product, reloadItem} = this.props
            const status = 'completed'

            const resUpdated = await apiBarcode.updateBarcodeProduct(item._id, product._id, {status})

            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)

            setTimeout(() => {
                const {barcodeNumber} = this.props
                return pushNewItemHistory(barcodeNumber, {
                    event_key: 'mark_as_printed',
                    event_description: 'Mark sleeve right as printed.',
                    event_meta: {
                        status
                    }
                })
            }, 0)

            await reloadItem()

            PubSub.publish('FOCUS_INPUT_SEARCH')
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingSleeveRightPrinting: false})
    }

    _handleCancel = () => {
        const r = window.confirm('Bạn có chắc chắn muốn hủy?')

        if (r) PubSub.publish('FOCUS_INPUT_SEARCH')
    }

    _handleDownloadDesign3D = async () => {
        const data = {
            maketplace: this.props.item.barcodeNumber,
            item_number: this.props.product.pos
        }

        await apiBarcode.getDesign3D(data)
    }

    _renderDesignImage = (src, style, alt, arx4Name) => {
        const support_3d_types = ['TSHIRT_3D', 'SWEATSHIRT_3D', 'HOODIE_3D', 'ZIP HOODIE 3D', 'TSHIRT_02', 'SW_18', 'HD_18', 'ZIP_HD_18']

        if (support_3d_types.indexOf(this.props.product.type.toUpperCase()) !== -1) {
            return <div className="cursor-pointer" onClick={this._handleDownloadDesign3D} target="_self"
                        rel="noopener noreferrer">
                <img src={src} style={style} alt={alt}/>
            </div>
        } else if (src && this.props.product.type.toUpperCase() !== 'TILE') {
            const arx6Types = [
                "T-SHIRT", "WOMEN T-SHIRT", "WOMEN POCKET T-SHIRT", "POCKET T-SHIRT", "FLIP T-SHIRT", "LONG_SLEEVE",  "V_NECK_TSHIRT",
                "KID T-SHIRT",
                "YOUTH T-SHIRT", "YOUTH POCKET T-SHIRT", "YOUTH_LONG_SLEEVE",
            ]

            const HOST = `http://192.168.1.253:5000`

            const url = !arx6Types.includes(this.props.product.type.trim().toUpperCase())
                ? `${HOST}/${arx4Name}.arx4`
                : `${HOST}/arx6/${arx4Name}.arx6`

            return <a href={url} target="_self" rel="noopener noreferrer">
                <img src={src} style={style} alt={alt}/>
            </a>
        } else {
            return <a href={src} target="_blank" rel="noopener noreferrer">
                <img src={src} style={style} alt={alt}/>
            </a>
        }
    }

    _renderMockUpImage = (src) => {
        if (src) {
            return <div className='mockUpImage' style={{backgroundImage: `url("${src}")`}}/>
        }

        return <div className='image'>150 x 200</div>
    }

    _handleChangeInput = (e) => {
        const {target: {name, value}} = e

        this.setState({[name]: value})
    }

    _renderIconNote = () => {
        if (this.state.isLoadingNote) {
            return <i className='icon-spinner2 spinner ml-2'/>
        }

        return <i className='icon-quill4 ml-2'/>
    }

    _handleSaveNote = async () => {
        this.setState({isLoadingNote: true})

        try {
            const {item} = this.props
            const {note} = this.state

            const resUpdated = await apiBarcode.updateBarcode(item._id, {note})

            const {success, message} = resUpdated.data

            if (!success) throw new Error(message)
        } catch (e) {
            alert(e.message)
        }

        this.setState({isLoadingNote: false})
    }

    _markWrongDesign = async () => {
        const {note} = this.state

        this.setState({
            validated: true
        })

        if (note) {
            if (window.confirm("Bạn có chắc chắn muốn đánh dấu sai design?")) {
                try {
                    const {item, pos, reloadItem} = this.props

                    this.setState({
                        isLoadingMarkWrong: true,
                        errorMarkWrong: ''
                    })

                    const {data: respons} = await apiBarcode.markWrongDesign(item.barcodeNumber, pos, {note})
                    const {success, message} = respons

                    if (!success) {
                        return this.setState({
                            isLoadingMarkWrong: false,
                            errorMarkWrong: message
                        })
                    }

                    this.setState({
                        isLoadingMarkWrong: false
                    }, async () => {
                        await reloadItem();
                        PubSub.publish('FOCUS_INPUT_SEARCH');
                    })
                } catch (e) {
                    this.setState({
                        errorMarkWrong: e.message
                    })
                }
            }
        }
    }

    render() {
        const {isLoadingFrontPrinting, isLoadingBackPrinting, note, validated, isLoadingMarkWrong, errorMarkWrong, isLoadingSleeveRightPrinting, isLoadingSleeveLeftPrinting, arrCanPrint} = this.state
        const {barcodeNumber, pos, product} = this.props
        const {
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            size,
            color,
            status: productStatus,
            designSleeveLeft,
            designSleeveRight
        } = product

        const urlMockUpFront = parseGGDriver(mockUpFront)
        const urlMockUpBack = parseGGDriver(mockUpBack)

        const urlDesignFront = parseGGDriver(designFront)
        const urlDesignBack = parseGGDriver(designBack)
        const urlDesignSleeveLeft = parseGGDriver(designSleeveLeft)
        const urlDesignSleeveRight = parseGGDriver(designSleeveRight)

        const isCompleted = productStatus === 'completed'
        const printItemClassName = classNames({PrintItem: true, Completed: isCompleted})
        const buttonColor = isCompleted ? 'success' : 'primary'
        const arx4Name = barcodeNumber.replace('#', '').split('_')[0] + '_' + pos.split('/')[0]
        const isDisabledFront = !arrCanPrint.includes('printed_front') || isCompleted || isLoadingFrontPrinting
        const isDisabledBack = !arrCanPrint.includes('printed_back') || isCompleted || isLoadingBackPrinting
        const isDisableSleeveLeft = !arrCanPrint.includes('printed_sleeves_left') || isCompleted || isLoadingSleeveLeftPrinting
        const isDisableSleeveRight = !arrCanPrint.includes('printed_sleeves_right') || isCompleted || isLoadingSleeveRightPrinting
        const alertMessage = urlDesignBack ? (urlDesignFront ? 'Cảnh báo! Áo này in hai mặt, sử dụng kẹp vàng!' : 'Cảnh báo! Áo này in mặt sau, cần đặt áo đúng mặt!') : ''
        const classNameFront = isDisabledFront ? ' Disabled' : ''
        const classNameBack = isDisabledBack ? ' Disabled' : ''
        const classNameSleebeLeft = isDisableSleeveLeft ? ' Disabled' : ''
        const classNameSleebeRight = isDisableSleeveRight ? ' Disabled' : ''

        return (
            <div className={printItemClassName}>
                <Card>
                    <CardHeader className='PrintItemHeader'>
                        <h4 className='d-flex justify-content-between align-items-center w-100 font-weight-bold mb-2'>
                            <div>
                                <span className='text-primary'>{barcodeNumber}</span>
                                <span className='ml-4'>{pos}</span>
                            </div>
                            <div>
                                <Button size='sm' onClick={this._handleCancel} className='Cancel'>
                                    Hủy lệnh in
                                    <i className='icon-cancel-square ml-2'/>
                                </Button>
                            </div>
                        </h4>
                    </CardHeader>

                    <CardBody>
                        <Row>
                            <Col md={4} className={'d-flex flex-column align-items-center'}>
                                <div className="TitlePrint">
                                    <div className='font-size-lg font-weight-bold'>MẶT TRƯỚC</div>
                                    {
                                        designSleeveLeft &&
                                        <div className='font-size-lg font-weight-bold'>TAY TRÁI</div>
                                    }
                                </div>

                                <div className="ContentMockup">
                                    <div className={'mockUp mt-3' + classNameFront}>
                                        <span className='Title'>Mock Up</span>
                                        {this._renderMockUpImage(urlMockUpFront)}
                                    </div>

                                    {
                                        designSleeveLeft && <div className={`mockUp mt-3 ${classNameSleebeLeft}`} >
                                            <span className='Title'>Mock Up</span>
                                            {this._renderMockUpImage(urlMockUpFront)}
                                        </div>
                                    }
                                </div>

                                <div className="ContentDesign">
                                    <div className={'design mt-3' + classNameFront}>
                                        <span className='Title'>Design</span>
                                        {this._renderDesignImage(urlDesignFront, {backgroundColor: color}, 'design front', arx4Name + '_F')}
                                    </div>

                                    {
                                        designSleeveLeft && <div className={`mockUp mt-3 ${classNameSleebeLeft}`}>
                                            <span className='Title'>Design</span>
                                            {this._renderDesignImage(urlDesignSleeveLeft, {backgroundColor: color}, 'design sleeve left', arx4Name + '_SL')}
                                        </div>
                                    }

                                </div>
                            </Col>

                            <Col md={4} className="CenterContent">
                                {
                                    alertMessage &&
                                    <Alert className='animate-flicker' color='danger'>{alertMessage}</Alert>
                                }

                                <div className='OrderActions d-flex flex-column align-items-center'>
                                    <Button color={buttonColor} onClick={this._handleClickPrintFront}
                                            className='ButtonLarge'
                                            disabled={isDisabledFront}>
                                        In xong mặt trước
                                        {this._renderIconPrintFront()}
                                    </Button>
                                    <Button color={buttonColor} className='ButtonLarge mt-3'
                                            onClick={this._handleClickPrintBack}
                                            disabled={isDisabledBack}>
                                        In xong mặt sau
                                        {this._renderIconPrintBack()}
                                    </Button>
                                    {designSleeveLeft && (
                                        <Button color={buttonColor} onClick={this._handleClickPrintSleeveLeft}
                                                className='ButtonLarge mt-3'
                                                disabled={isDisableSleeveLeft}>
                                            In xong tay trái
                                            {this._renderIconPrintSleeveLeft()}
                                        </Button>
                                    )}
                                    {designSleeveRight && (
                                        <Button color={buttonColor} onClick={this._handleClickPrintSleeveRight}
                                                className='ButtonLarge mt-3'
                                                disabled={isDisableSleeveRight}>
                                            In xong tay phải
                                            {this._renderIconPrintSleeveRight()}
                                        </Button>
                                    )}
                                </div>

                                <div className='OrderVariant mt-4'>
                                    <h3>Size: <span>{size}</span></h3>
                                    <h3>Color: <span>{color}</span></h3>
                                </div>

                                <div className='OrderNote'>
                                    <textarea
                                        className={className('form-control', (note === '' && validated) && 'border-danger')}
                                        name='note' value={note}
                                        onChange={this._handleChangeInput}
                                    />

                                    <div className='d-flex justify-content-between mt-2'>
                                        <button className='btn btn-primary btn-lg' onClick={this._handleSaveNote}>
                                            Save note
                                            {this._renderIconNote()}
                                        </button>

                                        <Button
                                            color="danger"
                                            className='btn-lg'
                                            onClick={this._markWrongDesign}
                                            disabled={isLoadingMarkWrong}
                                        >
                                            Sai Design
                                        </Button>
                                    </div>
                                </div>
                                {
                                    (note === '' && validated) && (
                                        <div className="text-danger mt-1">Vui lòng nhập chú thích</div>
                                    )
                                }

                                {
                                    errorMarkWrong && (
                                        <div className="text-danger mt-1 text-center">{errorMarkWrong}</div>
                                    )
                                }
                            </Col>

                            <Col md={4} className={'d-flex flex-column align-items-center'}>
                                <div className="TitlePrint">
                                    <div className='font-size-lg font-weight-bold'>MẶT SAU</div>

                                    {
                                        designSleeveRight &&
                                        <div className='font-size-lg font-weight-bold'>TAY PHẢI</div>
                                    }
                                </div>

                                <div className="ContentMockup">
                                    <div className={'mockUp mt-3' + classNameBack}>
                                        <span className='Title'>Mock Up</span>
                                        {this._renderMockUpImage(urlMockUpBack)}
                                    </div>

                                    {
                                        designSleeveRight && <div className={`mockUp mt-3 ${classNameSleebeRight}`}>
                                            <span className='Title'>Mock Up</span>
                                            {this._renderMockUpImage(urlMockUpBack)}
                                        </div>
                                    }
                                </div>

                                <div className="ContentDesign">
                                    <div className={'design mt-3' + classNameBack}>
                                        <span className='Title'>Design</span>
                                        {this._renderDesignImage(urlDesignBack, {backgroundColor: color}, 'design back', arx4Name + '_B')}
                                    </div>

                                    {
                                        designSleeveRight && <div className={`mockUp mt-3 ${classNameSleebeRight}`}>
                                            <span className='Title'>Design</span>
                                            {this._renderDesignImage(urlDesignSleeveRight, {backgroundColor: color}, 'design sleeve right', arx4Name + '_SR')}
                                        </div>
                                    }

                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default PrintItem
